export default __webpack_public_path__ + "static/32-776299ba05688a575a10f7460165b6a3.png";